/**
 * Generate a RFC 4122 v4 UUID.
 * crypto.randomUUID() requires a secure context (HTTPS).
 * This falls back to crypto.getRandomValues() for HTTP dev environments.
 */
export function generateUUID(): string {
  if (typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16)
  );
}
